import { FC } from 'react';
import { AllBuckets } from '../utils/derive';

const BUCKET_OPTIONS: { value: AllBuckets; label: string }[] = [
  { value: 'all',   label: 'All Buckets' },
  { value: 'b30',   label: '1-30 Days' },
  { value: 'b60',   label: '31-60 Days' },
  { value: 'b90',   label: '61-90 Days' },
  { value: 'b120',  label: '91-120 Days' },
  { value: 'b120p', label: '120+ Days' },
];

interface ResultToolbarProps {
  count: number;
  bucket: AllBuckets;
  onBucketChange: (b: AllBuckets) => void;
  onExpandAll: () => void;
  onCollapseAll: () => void;
}

const ResultToolbar: FC<ResultToolbarProps> = ({
  count,
  bucket,
  onBucketChange,
  onExpandAll,
  onCollapseAll,
}) => {
  return (
    <div className="ia-result-toolbar">
      <div className="ia-result-count">
        <strong>{count}</strong> placement{count !== 1 ? 's' : ''}
      </div>

      <div className="ia-bucket-select">
        <span>Aged Invoice Bucket:</span>
        <select
          value={bucket}
          onChange={(e) => onBucketChange(e.target.value as AllBuckets)}
        >
          {BUCKET_OPTIONS.map((opt) => (
            <option key={opt.value} value={opt.value}>
              {opt.label}
            </option>
          ))}
        </select>
      </div>

      <div className="ia-toolbar-actions">
        <button type="button" onClick={onExpandAll}>
          Expand All
        </button>
        <button type="button" onClick={onCollapseAll}>
          Collapse All
        </button>
      </div>
    </div>
  );
};

export default ResultToolbar;
